import { ITableColumn } from '@makyoapp/makyo-sdk/models/Table'

import { Cell, ICell } from '.'

export interface IPhoneColumn extends ITableColumn {
  Settings: null
}

export interface IPhoneCell extends ICell {
  settings: null
}

export class PhoneCell implements IPhoneCell {
  value: Cell
  settings: null

  constructor(value: Cell, settings: null) {
    this.value = value
    this.settings = settings
  }

  toString(): string {
    if (this.value === null || this.value === undefined) {
      return ''
    }
    let stringVal = this.value?.toString()
    if (!stringVal?.trim()) return ''
    return stringVal
  }

  toCell<T extends Cell>(newValue: T) {
    if (!newValue || typeof newValue !== 'string') {
      this.value = ''
      return this
    }

    this.value = newValue
    return this
  }
}
